import { useMemo } from "react";
import { Endpoints, queryKeys } from "../api";
import { useAuth, useQueryParams } from "../contexts";
import { getRequestOptions } from "../helper-functions";
import { useAxios, useGenericQuery } from "../hooks";
import { CaseFileCategory, Entity, IUseQueryPaged } from "../models";

export const useCaseFileCategoryQuery = (): Pick<IUseQueryPaged<CaseFileCategory>, "listQuery"> => {
    const { isAuthorized } = useAuth();
    const { get } = useAxios();
    const { queryParams, sortParams } = useQueryParams().getParamsApi(Entity.CaseFileCategories);
    const url = `${Endpoints.CaseFiles}/categories`;

    const listQuery = useGenericQuery({
        queryFn: (config) =>
            get<CaseFileCategory[]>(getRequestOptions(url, config, queryParams, sortParams, undefined, false, true)),
        queryKey: queryKeys.caseFileCategories.list({ ...queryParams, ...sortParams }),
        placeholderData: [],
        enabled: isAuthorized,
    });

    return useMemo<Pick<IUseQueryPaged<CaseFileCategory>, "listQuery">>(
        () => ({
            listQuery,
        }),
        [listQuery]
    );
};
